import GenericAreaPage from "@/components/GenericAreaPage";
import { getAreaContent } from "@/lib/area-content";

const Montrose = () => {
  const content = getAreaContent("montrose");
  if (!content) return null;
  return <GenericAreaPage content={content} />;
};

export default Montrose;